import { defineComponent as _defineComponent } from 'vue'
import { usePage } from './useBase'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFound',
  props: {
    text: { default: '抱歉，您访问的页面不存在' }
  },
  setup(__props: any) {



usePage()

return { __sfc: true, }
}

})